import {Component} from '@angular/core';
import {ChangeDetectorRef} from '@angular/core';

import {NavController, ModalController, Platform} from 'ionic-angular';

import {Data} from '../../providers/providers';

import {LocationListPage} from "../location-list/location-list";

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  userEmail: string;

  constructor(public navCtrl: NavController,
              public modalCtrl: ModalController, // TEMP
              public data: Data) {
  }

  openLocations() {
    this.navCtrl.push(LocationListPage);
  }
}




// WEBPACK FOOTER //
// ./src/pages/home/home.ts